import { currentWallet } from '@cronos-app/wallet';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signAndLogin } from '@ui/utils/signAndLogin';

export const useLogin = (onSuccess?: () => void, onError?: () => void) => {
  const walletAddress = currentWallet.useAccount();
  const provider = currentWallet.useProvider();
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      if (!walletAddress) throw new Error('Wallet address is undefined');
      await signAndLogin(walletAddress, provider);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['useIsAuthenticated'] });
        queryClient.invalidateQueries(['useUserProfile']);
        onSuccess?.();
      },
      onError,
    },
  );
};
